(() => {
  let ignoreScrollUntil = 0;
  let scrollRaf = null;

  function getSliderComponentFromControls(controls) {
    return controls.closest('slider-component');
  }

  function getSliderFromControls(controls) {
    const sliderComponent = getSliderComponentFromControls(controls);
    return sliderComponent?.querySelector('[id^="Slider-Gallery"]');
  }

  function setProgress(controls, current) {
    const slider = getSliderFromControls(controls);
    const fill = controls.querySelector('.product-media-carousel__progress-fill');
    const total = slider?.querySelectorAll('.slider__slide').length || 1;

    if (!fill) return;

    const nextCurrent = Math.min(Math.max(current, 1), total);
    controls.dataset.progressCurrent = nextCurrent;

    fill.style.setProperty('transform', `scaleX(${nextCurrent / total})`, 'important');
  }

  function syncProgressFromSlider(slider) {
    const sliderComponent = slider.closest('slider-component');
    const controls = sliderComponent?.querySelector('.product-media-carousel__controls');
    if (!controls) return;

    const total = slider.querySelectorAll('.slider__slide').length || 1;
    const maxScroll = slider.scrollWidth - slider.clientWidth;

    if (maxScroll <= 0) return;

    const progress = slider.scrollLeft / maxScroll;
    const current = Math.round(progress * (total - 1)) + 1;

    setProgress(controls, current);
  }

  function initProgressBars() {
    document
      .querySelectorAll('slider-component:not([style*="display: none"]) .product-media-carousel__controls')
      .forEach((controls) => {
        if (!controls.dataset.progressCurrent) {
          setProgress(controls, 1);
        }
      });
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.product-media-carousel__controls .slider-button');
      if (!button || button.disabled) return;

      const controls = button.closest('.product-media-carousel__controls');
      if (!controls) return;

      const current = Number(controls.dataset.progressCurrent || 1);

      ignoreScrollUntil = Date.now() + 400;

      if (button.name === 'next') setProgress(controls, current + 1);
      if (button.name === 'previous') setProgress(controls, current - 1);
    },
    true
  );

  document.addEventListener(
    'scroll',
    (event) => {
      if (Date.now() < ignoreScrollUntil) return;

      const slider = event.target?.closest?.('[id^="Slider-Gallery"]');
      if (!slider) return;

      if (scrollRaf) cancelAnimationFrame(scrollRaf);

      scrollRaf = requestAnimationFrame(() => {
        syncProgressFromSlider(slider);
      });
    },
    true
  );

  document.addEventListener('DOMContentLoaded', initProgressBars);
  window.addEventListener('load', initProgressBars);
  setTimeout(initProgressBars, 500);
  setTimeout(initProgressBars, 1500);
  document.addEventListener('shopify:section:load', initProgressBars);
})();